import { Fragment } from "react";

import ReleaseNotesData from "../Helper/ReleaseNotesData";
import { styles } from "./util";

const InternalOnlyReleaseNotes = ({ internalOnly, type }) => {
  // Filter release notes based on internalOnly and type props
  const filteredNotes = ReleaseNotesData()
    .map(({ component, devOnlyNotes }) => ({
      component,
      notes: devOnlyNotes.filter(
        (note) => note.IssueType.includes(type) && (note.ReleaseNotes.toLowerCase().includes(internalOnly) || note.InternalOnly),
      ),
    }))
    .filter(({ notes }) => notes.length > 0);

  // If there are any filtered release notes, render them in a list
  const internalOnlyNotes =
    filteredNotes.length > 0 ? (
      <Fragment>
        {filteredNotes.map(({ component, notes }, i) => (
          <Fragment key={i}>
            <h3 style={styles.component}>{component}</h3>
            {notes.map(({ ReleaseNotes }, noteIndex) => (
              <ul key={noteIndex}>
                <li>{`${ReleaseNotes.replace("*****", "").replace(/(DEV ONLY:|Dev Only:)\s*/g, "")}`}</li>
              </ul>
            ))}
          </Fragment>
        ))}
      </Fragment>
    ) : null;

  return <div style={styles.notes}>{internalOnlyNotes}</div>;
};

export default InternalOnlyReleaseNotes;
